module.exports = __webpack_public_path__ + "img/section-3-content_bottom_img2.a945b650.png";